import session from "../../services/session";
import swal from "sweetalert2";
import AdminApi from "../../services/api";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()


export default {
    data() {
        return {
            locale: LocService,
            title : '',
            model: {
                name: '',
                enName: '',
            },
            partnerCompanies: [],
            idToEdit: null,
            fromDate : null,
            toDate: null,
            chooseUser: false,
            selectedPartnerCompany: null,
            selectedUsers: [],
            isVisibleAddUserToTerm: false,
            showAddTrainerToSlot: false,
        }
    },
    methods: {
        copyPersonalProgram: copyPersonalProgram,
        showChoseUser: showChoseUser,
        getPersonalProgramById: getPersonalProgramById,
        loadCompanyPartner: loadCompanyPartner,
        removeSelectedUser: removeSelectedUser,
    },
    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_TRAINER') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.idToEdit = this.$route.query.id;
        this.fromDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.toDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.showAddTrainerToSlot = CONFIG_COMPANY.SHOW_ADD_TRAINER_ON_SLOT;
        this.isVisibleAddUserToTerm = session.getConfig().canAddUserWithTerm;
        if(this.idToEdit != null){
            this.getPersonalProgramById();
        }
        this.loadCompanyPartner();
    },
    created() {
        let _self = this;
        this.$topnavbar.$on('closeChooseUser', () => {
            _self.chooseUser = false;
        });

        this.$topnavbar.$on('onUserSelected', (data) => {
            // _self.chooseUser = false;
            if(!_self.selectedUsers.map(u => u.id).includes(data.id)){
                _self.selectedUsers.push(data)
            }
        });
    }
}

function loadCompanyPartner() {
    let _self = this;

    AdminApiService.getCompanyPartners()
        .then((response) => {
            _self.partnerCompanies = response.data
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function getPersonalProgramById(){
    let _self = this;
    AdminApiService.getPersonalProgramById(this.idToEdit, false)
        .then((response) => {
            let data = response.data.details;
            _self.model.name = data.name
            _self.model.enName = data.enName
            _self.fromDate = _self.$moment(data.startTime * 1000).format('YYYY-MM-DD');
            _self.toDate = _self.$moment(data.endTime * 1000).format('YYYY-MM-DD');
            // On copy page these must always start empty.
            _self.selectedUsers = []
            _self.title = data.name
            _self.selectedPartnerCompany = null

        })
        .catch(error => {
            swal( LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function removeSelectedUser(sUser){
    this.selectedUsers = this.selectedUsers.filter(u => sUser.id !== u.id)
    // this.selectedUsers = [];
    // this.selectedUsers = null;
}
function showChoseUser(){
    this.chooseUser = true;
}


function copyPersonalProgram() {
    let _self = this;
    if(_self.model.name.length === 0){
        swal( LocService.t('label_error'), LocService.t('label_td_name_required'), 'error')
        return;
    }
    const hasUser = this.selectedUsers != null && this.selectedUsers.length > 0;
    const hasPartnerCompany = _self.selectedPartnerCompany != null && ('' + _self.selectedPartnerCompany).trim().length > 0;
    if(!hasUser && !hasPartnerCompany){
        swal(LocService.t('label_error'), LocService.t('label_pp_choose_user_or_partner'), 'error')
        return;
    }
    var model = {
        id: this.idToEdit,
        type: "PERSONAL",
        fromDate: _self.$moment(_self.fromDate).format('DD-MM-YYYY'),
        toUser: this.selectedUsers.map(e => e.id)[0],
        name: _self.model.name,
        enName: _self.model.enName,
        toPartnerCompany: _self.selectedPartnerCompany,
    }

    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte...</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {});


    AdminApiService.copyPersonalProgram(model)
        .then((response) => {
            swal(LocService.t("label_success"), LocService.t("label_pp_success_saved"), 'success')
            this.$router.back()
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}



// WEBPACK FOOTER //
// ./src/components/Personal/CopyPersonalProgram.js